module.exports = __webpack_public_path__ + "img/hic-digestive-diseases-male.1594ffb6.png";